import { render, staticRenderFns } from "./ProductVariantTitleNew.vue?vue&type=template&id=2264398f&scoped=true&"
import script from "./ProductVariantTitleNew.vue?vue&type=script&lang=js&"
export * from "./ProductVariantTitleNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantTitleNew.vue?vue&type=style&index=0&id=2264398f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264398f",
  null
  
)

export default component.exports